import { render, staticRenderFns } from "./KcMain.vue?vue&type=template&id=d9629610&scoped=true"
import script from "./KcMain.vue?vue&type=script&lang=js"
export * from "./KcMain.vue?vue&type=script&lang=js"
import style0 from "./KcMain.vue?vue&type=style&index=0&id=d9629610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9629610",
  null
  
)

export default component.exports